var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Form, Field, Control } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import _ from 'lodash';

import { Icon, ToggleButton } from "../../UI";
import { MarkDown } from "../../ReactReduxForms";
import {
resetPage as resetPageAction,
savePage as savePageAction,
updateValue as updateValueAction } from "../actions/pageActions";

import ShowIf from "../../App/ShowIf";
import { BackButton } from "../../Layout";
import { Translate, I18NLink } from "../../I18N";


import validator from "./ValidatePage";

const mapStateToProps = ({ page }) => ({
  page,
  formState: page.formState,
  savingPage: page.uiState.get('savingPage')
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{ resetPage: resetPageAction, savePage: savePageAction, updateValue: updateValueAction },
dispatch);


const connector = connect(mapStateToProps, mapDispatchToProps);



class PageCreator extends Component {
  componentWillUnmount() {
    const { resetPage } = this.props;
    resetPage();
  }

  render() {
    const { formState, page, savePage, updateValue, savingPage } = this.props;
    const backUrl = '/settings/pages';
    const pageUrl = `/page/${page.data.sharedId}/${_.kebabCase(page.data.title)}`;

    let nameGroupClass = 'template-name form-group';
    if (
    formState.title &&
    !formState.title.valid && (
    formState.submitFailed || formState.title.touched))
    {
      nameGroupClass += ' has-error';
    }

    return /*#__PURE__*/(
      _jsx("div", { className: "page-creator" }, void 0, /*#__PURE__*/
      _jsx(Form, { model: "page.data", onSubmit: savePage, validators: validator() }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "metadataTemplate-heading panel-heading" }, void 0, /*#__PURE__*/
      _jsx("div", { className: nameGroupClass }, void 0, /*#__PURE__*/
      _jsx(Field, { model: ".title" }, void 0, /*#__PURE__*/
      _jsx("input", { placeholder: "Page name", className: "form-control" })))), /*#__PURE__*/



      _jsx("div", { className: "panel-body page-viewer document-viewer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "entity-view" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Enable this page to be used as an entity view page:"), /*#__PURE__*/
      _jsx(Control, {
        model: ".entityView",
        component: ToggleButton,
        checked: Boolean(page.data.entityView),
        onClick: () => {
          updateValue('.entityView', !page.data.entityView);
        } })), /*#__PURE__*/


      _jsx(ShowIf, { if: Boolean(page.data._id) && !page.data.entityView }, void 0, /*#__PURE__*/
      _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "angle-right" }), " ", pageUrl, "\xA0", /*#__PURE__*/

      _jsx("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: pageUrl,
        className: "pull-right" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "(view page)")))), /*#__PURE__*/



      _jsx(MarkDown, {
        htmlOnViewer: true,
        model: ".metadata.content",
        rows: 18,
        showPreview: !page.data.entityView }), /*#__PURE__*/

      _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle", size: "2x" }), /*#__PURE__*/
      _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Use"), ' ', /*#__PURE__*/
      _jsx("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://guides.github.com/features/mastering-markdown/" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Markdown")),
      ' ', /*#__PURE__*/
      _jsx(Translate, {}, void 0, "syntax to create page content"), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "You can also embed advanced components like maps, charts and entity lists in your page."), "\xA0", /*#__PURE__*/




      _jsx("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://uwazi.readthedocs.io/en/latest/admin-docs/analysing-and-visualising-your-collection.html" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Click here")),
      ' ', /*#__PURE__*/
      _jsx(Translate, {}, void 0, "to learn more about the components."))), /*#__PURE__*/


      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("span", { className: "form-group-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Page Javascript"))), /*#__PURE__*/


      _jsx("div", { className: "alert alert-warning" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle", size: "2x" }), /*#__PURE__*/
      _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "With great power comes great responsibility!"), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This area allows you to append custom Javascript to the page. This opens up a new universe of possibilities."), /*#__PURE__*/



      _jsx("br", {}), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "It could also very easily break the app. Only write code here if you know exactly what you are doing."))), /*#__PURE__*/





      _jsx(Field, { model: ".metadata.script" }, void 0, /*#__PURE__*/
      _jsx("textarea", {
        placeholder: "// Javascript - With great power comes great responsibility!",
        className: "form-control",
        rows: 12 }))))), /*#__PURE__*/





      _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
      _jsx(BackButton, { to: backUrl, className: "btn-plain" })), /*#__PURE__*/

      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: backUrl, className: "btn btn-extra-padding btn-default" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Cancel"))), /*#__PURE__*/


      _jsx("button", {
        type: "submit",
        className: "btn btn-extra-padding btn-success save-template",
        disabled: !!savingPage }, void 0, /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save"))))))));







  }
}

const container = connector(PageCreator);


export { container as PageCreator };